import { render, staticRenderFns } from "./AdvertisingTaxInput.vue?vue&type=template&id=085cc2c4"
import script from "./AdvertisingTaxInput.vue?vue&type=script&lang=js"
export * from "./AdvertisingTaxInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports